import { useTranslation } from "@opendash/i18n";
import { Checkbox, DatePicker } from "antd";
import dayjs from "dayjs";
import React, { useEffect } from "react";
export const StartDatePicker = ({ value, onChange, onlyWeeks, setOnlyWeeks, }) => {
    const t = useTranslation();
    const defaultValue = dayjs().second(0).minute(0).hour(8);
    useEffect(() => {
        // Propagate the current set date to oChange so that it can be used by EndDatePicker.
        // Otherwise it might be undefined.
        onChange(value ? value : defaultValue);
    }, []);
    return (React.createElement(DatePicker, { onChange: (date, dateString) => {
            if (date !== null) {
                onChange(date);
            }
        }, renderExtraFooter: () => {
            //Add a Checkbox for week selection
            return (React.createElement(Checkbox, { defaultChecked: onlyWeeks, onChange: (e) => {
                    setOnlyWeeks(e.target.checked);
                    onChange(value);
                } }, "Auswahl von Kalenderwochen"));
        }, picker: onlyWeeks ? "week" : "date", value: value, defaultValue: defaultValue, style: { width: "100%" }, showTime: { format: "HH:mm" }, format: onlyWeeks
            ? `[${t("maintenance:schedule.calendarweek.abbreviation")}] WW in YYYY`
            : "DD.MM.YYYY @ HH:mm" }));
};
//# sourceMappingURL=StartDatePicker.js.map